import { Button, Form, Input, message } from "antd";
import { useTranslation } from "react-i18next";
import { Auth } from "aws-amplify";
import { CognitoUser } from "amazon-cognito-identity-js";

type FieldTypePassword = {
  newPassword: string;
  confirmedNewPassword: string;
};

interface CreatePasswordFormProps {
  challengeUser: CognitoUser | null;
  onBackToLogin: (value: React.SetStateAction<boolean>) => void;
}

export function CreatePasswordForm({
  challengeUser,
  onBackToLogin,
}: CreatePasswordFormProps) {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const validatePasswordsMatch = (
    newPassword: string,
    confirmedPassword: string
  ) => {
    if (newPassword !== confirmedPassword) {
      return false;
    }
    return true;
  };

  const handleCreatePassword = async (
    newPassword: string,
    confirmedPassword: string
  ) => {
    const passwordsMatch = validatePasswordsMatch(
      newPassword,
      confirmedPassword
    );
    if (!passwordsMatch) {
      form.setFields([
        {
          name: "confirmedNewPassword",
          errors: [t("create-new-password:password-match-validation-error")],
        },
      ]);
      return;
    }

    try {
      await Auth.completeNewPassword(challengeUser, newPassword);
      message.success(t("create-new-password:create-password-success"));
      setTimeout(() => {
        onBackToLogin(false);
      }, 2000);
    } catch (error: any) {
      message.error(
        error.message || t("create-new-password:create-password-error")
      );
    }
  };

  return (
    <Form
      form={form}
      name="basic"
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
      className="reset-form-container"
      initialValues={{ remember: true }}
      onFinish={(values) =>
        handleCreatePassword(values.newPassword, values.confirmedNewPassword)
      }
      autoComplete="off"
      requiredMark={false}
    >
      <h1 style={{ color: "white", margin: "40px 0 40px 0" }}>
        {t("create-new-password:title")}
      </h1>
      <Form.Item<FieldTypePassword>
        label={<span className="form-label">{t("login:password")}</span>}
        name="newPassword"
        style={{ color: "white" }}
        rules={[
          {
            required: true,
            message: t("login:password-validation-error"),
          },
        ]}
      >
        <Input.Password style={{ fontSize: "16px", height: "40px" }} />
      </Form.Item>

      <Form.Item<FieldTypePassword>
        label={
          <span className="form-label">
            {" "}
            {t("create-new-password:confirm-password")}
          </span>
        }
        name="confirmedNewPassword"
        style={{ color: "white" }}
        rules={[
          { required: true, message: t("login:password-validation-error") },
        ]}
      >
        <Input.Password style={{ fontSize: "16px", height: "40px" }} />
      </Form.Item>

      <Form.Item label={null}>
        <Button
          type="primary"
          htmlType="submit"
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            marginTop: "15px",
            height: "40px",
          }}
        >
          <span style={{ color: "white", fontSize: "16px" }}>
            {t("password-reset:submit")}
          </span>
        </Button>
      </Form.Item>
      <Form.Item>
        <span
          style={{ color: "white", cursor: "pointer" }}
          onClick={() => onBackToLogin(false)}
        >
          <i> {t("password-reset:back-to-login")}</i>
        </span>
      </Form.Item>
    </Form>
  );
}
